<template>
  <header v-if="!['/login','/register','/protocol','/forgetpwd'].includes(path)" class="index_header">
    <div class="header_title">
      <a href="http://www.xinhuaqu.gov.cn/" target="_blank" ><img class="img1" src="@/assets/image/zf_xhq.png" alt="" /></a>
      <a href="https://www.hnzwfw.gov.cn/" target="_blank" ><img class="img2" src="@/assets/image/zf_henan.png" alt="" /></a>
      <div class="name_logo">新华区网上中介超市</div>
      <a-popover v-model:visible="visible" title="新华区" trigger="click">
        <a-button class="header_search_btn" type="primary"> {{state.currentAddress}}<DownOutlined :rotate="isRotate" /> </a-button>
        <template #content>
          <div  class="session_box"> <div @click="selectAddress(item)" v-for="(item, index) in state.addRessList" :key="index"> {{ item.name }} </div> </div>
        </template>
      </a-popover>
      <div v-if="store.state.token" class="login_box2">
        <img src="@/assets/image/login_user.png" alt="" />
        <div>
          <p>欢迎您，</p>
          <p>{{store.getters.userInfo.user_type==2?store.getters.userInfo.company_name:store.getters.userInfo.true_name}}</p>
        </div>
        <!-- <a-button> <template #icon> <MoreOutlined /> </template> </a-button> -->
        <a-dropdown placement="bottomRight">
          <a class="ant-dropdown-link" @click.prevent> <MoreOutlined /> </a>
          <template #overlay>
            <a-menu>
              <a-menu-item v-if="store.getters.userInfo.user_type!=1" @click="onSystemList(1)" > <a>进入管理后台</a> </a-menu-item>
              <a-menu-item @click="onSystemList(2)" > <a>退出系统</a> </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
      </div>
      <div v-else class="login_box">
        <a @click="router.push('/login')">登录 </a>&nbsp;|&nbsp; 
        <a @click="router.push('/register')">注册</a>
      </div>
    </div>
    <ul class="index_menu">
      <li @click="returnPage(item.path)" :class="item.children.includes(path) ? 'current' : 'touming'" v-for="(item, index) in menuList" :key="index" >
        <span>{{ item.name }}</span>
      </li>
    </ul>
  </header>
  <a-config-provider :locale="locale">
    <router-view></router-view>
  </a-config-provider>
</template>

<script>
import { useStore } from "vuex";
import { DownOutlined, MoreOutlined } from "@ant-design/icons-vue";
import { useRoute, useRouter } from "vue-router";
import { ref, computed, reactive, onMounted, watch, onBeforeMount } from "vue";
import { getCityListApi,getOutLoginApi } from "@/apis/index.js";
import { message } from 'ant-design-vue';
import zhCN from "ant-design-vue/es/locale/zh_CN";
const menuList = [ { name: "首页", path: "/", children: ["/", "index"], }, 
  { name: "服务事项", path: "/serve", children: ["/serve", "/serveDetail"], }, 
  { name: "中介机构", path: "/intermediary", children: ["/intermediary", "/intermediaryDetail", "/creditDetail/allServe",], }, 
  { name: "采购公告", path: "/purchase", children: ["/purchase", "/purchaseDetail"], }, 
  { name: "选取公示", path: "/select", children: ["/select", "/selectDetail"], }, 
  { name: "通知公告", path: "/inform", children: ["/inform", "/informDetail"], }, 
  { name: "合同管理", path: "/contract", children: ["/contract", "/contractDetail"], },
  { name: "信用公示", path: "/credit", children: [ "/credit", "/creditDetail", "/creditDetail/qualificationInfo",
    "/creditDetail/beChosenRecord", "/creditDetail/creditInfo", "/creditDetail/serveInfo", "/creditDetail/userInfo", "/fileDetail", ], }, 
  { name: "服务咨询", path: "/serveZixun", children: ["/serveZixun", "/serveZixunDetail"], }, 
  { name: "政策法规", path: "/policy", children: ["/policy", "/policyDetail"], },
];
export default {
  components: {
    DownOutlined,
    MoreOutlined,
  },

  setup() {
    const store = reactive(useStore());
    const locale = reactive(zhCN);
    const state = reactive({
      addRessList: [],
      currentAddress:'全部地区',
      addressId:'',
    });
    let path = ref(new String());
    let router = reactive(useRouter());
    const getCityList = async () => {
      const { data: res } = await getCityListApi();
      const all = {id: null, pid: 1, name: "全部地区"}
      res.data.list.unshift(all)
      state.addRessList = res.data.list
    };


    getCityList();
    onMounted(() => {
      path.value = useRoute().path;
    });
    const selectAddress = (item)=>{
      state.addressId = item.id
      state.currentAddress = item.name
      store.commit('getAddRessId',item.id)
    }
    const visible = ref(false);
    const hide = () => {
      visible.value = false;
    };
    let html = document.getElementsByTagName("html");


    let isRotate = computed(() => {
      if (visible.value) {
        return 0;
      } else {
        return 180;
      }
    });

    const route = useRoute();
    watch(
      () => route.path,
      (newval, oldval) => {
        path.value = newval;
      },
      { immediate: true }
    );
    watch(
      () => visible.value,
      (newval, oldval) => {
        // console.log('监听到变化',newval);
        if (newval) {
          html[0].style.overflow = "hidden";
        } else {
          html[0].style.overflow = "auto";
        }
      },
      { immediate: true }
    );
    
    function returnPage(url) {
      if (route === path) return false;
      router.push(url);
    }
    const onSystemList =async e => {
      if(e==1){
        window.location.href =  location.origin + '/zhongjie'
      }else if(e==2){
        const {data:res} = await getOutLoginApi()
        if(res.code==200){
          message.success(res.msg);
          store.commit("clearUserInfo");
        }else{
          message.error(res.msg);
        }
      }
    };
    return {
      router,
      store,
      visible,
      hide,
      isRotate,
      menuList,
      path,
      returnPage,
      locale,
      onSystemList,
      state,
      selectAddress
    };
  }
};
</script>

<style scoped lang="scss">
.index_header {
  height: 180px;
  width: 100%;
  background-color: #fff;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  border-bottom: 1px solid #e2e2e2;
}
.login_box2 {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  font-size: 14px;
  color: #2e5aa6;
  & > img {
    width: 24px;
    height: 24px;
    margin: 7px 10px 0 0;
  }
  .ant-dropdown-link {
    width: 40px;
    height: 40px;
    line-height: 45px;
    text-align: center;
    margin: 0 0 0 20px;
    border-radius: 4px;
    background: #e5e5e5;
    border: none;
    span {
      font-size: 24px;
      color: #2e5aa6;
    }
  }
}
.login_box {
  flex: 1;
  text-align: right;
  cursor: pointer;
  margin-right: 50px;
}
.index_menu {
  display: flex;
  width: 1200px;
  margin: 0 auto;
  justify-content: space-between;
  font-size: 16px;
  height: 53px;
  align-items: center;
}
.index_menu li {
  flex: 1;
  cursor: pointer;
  display: flex;
  justify-content: center;
  padding-bottom: 10px;
  span {
    width: 100%;
    border-right: 1px solid #e2e2e2;
    text-align: center;
  }
}
.index_menu li:last-child {
  span {
    border: none;
  }
}
.index_menu li:hover {
  border-bottom: 4px solid #ecc299;
}
.current {
  border-bottom: 4px solid #ecc299;
}
.touming {
  border-bottom: 4px solid rgba(0, 0, 0, 0);
}
.header_title {
  padding: 0 120px;
  display: flex;
  align-items: center;
  height: 124px;
  .img1 {
    height: 105px;
  }
  .img2 {
    height: 60px;
    padding: 6px 12px;
    margin-right: 12px;
    border-left: 1px solid #000;
    border-right: 1px solid #000;
  }
}
.name_logo {
  color: #2e5aa6;
  font-size: 20px;
  font-weight: 600;
  vertical-align: middle;
}
.header_search_btn {
  background-color: #e1e5f1;
  color: #2e5aa6;
  border: none;
  margin-left: 30px;
}
.session_box {
  max-width: 500px;
  display: flex;
  flex-wrap: wrap;
  div {
    margin: 0 10px;
    cursor: pointer;
  }
}
</style>
